import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateProjectBankFile } from 'scenes/ProjectBank/services/postCreateProjectBankFile.service';

export const createProjectBankFile = createAsyncThunk(
  'projectBank/createProjectBankFile',
  async (filePermission) => {
    const { silent, ...payload } = filePermission;
    const createdFilePermission = await postCreateProjectBankFile(payload);

    return createdFilePermission;
  }
);
